import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils/cn'

const statusCircleVariants = cva('h-2 w-2 block rounded-full border ', {
    variants: {
        variant: {
            default: 'bg-primary border-primary',
            'primary-outline': 'border-primary',
            secondary: 'bg-secondary border-secondary',
            'secondary-outline': 'border-secondary',
            destructive: 'bg-destructive border-destructive',
            'destructive-outline': 'border-destructive',
            success: 'bg-success border-success',
            'success-outline': 'border-success',
            warning: 'bg-warning border-warning',
            'warning-outline': 'border-warning',
            outline: 'bg-transparent border-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
})

export interface StatusCircleProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof statusCircleVariants> {}

function StatusCircle({ className, variant, ...props }: StatusCircleProps) {
    return <span className={cn(statusCircleVariants({ variant }), className)} {...props} />
}

export { StatusCircle, statusCircleVariants }
